import React from 'react';
import classNames from 'classnames';
import iconArrowDown from '../../../../Public/Icons/icon-arrowdown.svg';

export class AccordionItem extends React.Component {
  render() {
    return (
      <div
        className={classNames('card accordion-item', {
          open: this.props.show,
        })}
      >
        <div
          className="row row--with_margin card-header bg-white accordion-header pointer"
          onClick={(e) => this.props.clickHandler(e, this.props.index)}
        >
          <h4 className="col">{this.props.title}</h4>
          <img className="col-auto icon-state" src={iconArrowDown} />
        </div>
        <div
          className={classNames('accordion-content collapse', {
            show: this.props.show,
          })}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

export class Accordion extends React.Component {
  constructor(props) {
    super(props);

    this.state = { open: props.open };
  }

  onClick = (e, index) => {
    if (index === this.state.open) {
      this.setState({ open: null });
    } else {
      this.setState({ open: index });
    }
  };

  render() {
    // Add the open state as a prop to the children
    const childrenWithProps = React.Children.map(
      this.props.children,
      (child, key) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            show: key === this.state.open,
            clickHandler: this.onClick,
            index: key,
          });
        }
        return child;
      }
    );

    return <div className="accordion">{childrenWithProps}</div>;
  }
}
